import { render, staticRenderFns } from "./ProPasswordSuccessView.vue?vue&type=template&id=6a5c9b24"
import script from "./ProPasswordSuccessView.vue?vue&type=script&lang=js"
export * from "./ProPasswordSuccessView.vue?vue&type=script&lang=js"
import style0 from "./ProPasswordSuccessView.vue?vue&type=style&index=0&id=6a5c9b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports